import { useContext, useMemo } from "react";
import { ApiResponseType, makeRequest } from "../helpers/api.helpers";
import { createDebounce } from "../helpers/debounce.helper";
import { AuthContext } from "../components/auth/authContext/AuthContext";

const API_URL = import.meta.env.VITE_API_URL;

const makeRequestDebounced = createDebounce(makeRequest, 200);

export async function getProfile() {
  const url = `${API_URL}/profile`;

  const result = (await makeRequestDebounced(url)) as Promise<
    ApiResponseType<unknown>
  >;

  return result;
}

export const useUser = () => {
  const { auth } = useContext(AuthContext);

  const user = useMemo(
    () =>
      auth?.user || {
        name: "Guest",
        email: "email@example.com",
      },
    [auth],
  );

  return user;
};
